import { SalesRepresentative } from '../../sales-representative/sales-representative.types';
import { OfflineDatabaseSalesRepresentative } from '../database/offlineDatabase/types/offlineDatabaseSalesRepresentative.types';

export class OfflineDatabaseSalesRepresentativeTransformer {
  static toOnlineSalesRepresentative(
    salesRepresentative: OfflineDatabaseSalesRepresentative,
  ): SalesRepresentative {
    return {
      active: true,
      description: '',
      id: salesRepresentative.id,
      code: salesRepresentative.code,
      name: salesRepresentative.name,
    };
  }
}
